import { ProgressiveImage } from "@circle-react/components/shared/ProgressiveImage";
import { isEventPost } from "@circle-react/helpers/postHelpers";
import type { BasicPost, Event } from "@circle-react/types";
import type { MouseEvent } from "react";

import { t } from "@/i18n-js/instance";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";
import { classNames } from "@/react/helpers/twMergeWithCN";

import { ShowPageLink } from "./ShowPageLink";

export interface PostCoverImageProps {
  className?: string;
  endsAt?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  post: BasicPost | Event;
  startsAt?: string;
  timeZone?: string;
  wrapperClassName?: string;
}

export const PostCoverImage = ({
  post,
  className = "",
  wrapperClassName = "",
  ...rest
}: PostCoverImageProps) => {
  const isEventPostType = isEventPost(post);
  const coverImageUrl =
    post.cover_image_variants?.large ?? post.cover_image_url;

  if (!coverImageUrl) {
    return null;
  }

  return (
    <div className={classNames("px-4 pt-0 md:p-0", wrapperClassName)}>
      <ShowPageLink
        shouldOpenPostModal
        post={post}
        className={classNames(
          anchorClassNames("post__cover"),
          "block focus-visible:rounded-md focus-visible:text-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-secondary focus-visible:md:rounded-b-none",
        )}
        {...rest}
      >
        {post.cover_image_variants && (
          <ProgressiveImage
            key={post.cover_image_url ?? ""}
            src={post.cover_image_url ?? ""}
            srcVariants={post.cover_image_variants}
            alt={t("post.cover_image_alt")}
            className={classNames(
              "w-full object-cover",
              className,
              "rounded-md",
              { "md:rounded-b-none lg:rounded-none": !isEventPostType },
            )}
          />
        )}
      </ShowPageLink>
    </div>
  );
};
